import * as React from 'react';

import _ from 'underscore';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import type ReviewSchemaPart from 'pages/open-course/peerReview/reviewTypes/structured/partTypes/yesNo/models/schema';

import InlineValidationErrorV2 from 'bundles/assess-common/components/InlineValidationErrorV2';
import type { YesNoStructuredPart, YesNoStructuredPartDefinition } from 'bundles/assess-common/types/Reviews';
import type { ValidationError } from 'bundles/assess-common/types/ValidationErrors';
import Content from 'bundles/phoenix/components/Content';

import _t from 'i18n!nls/ondemand';

import 'css!./__styles__/YesNoFormPart';

type Props = {
  disabled: boolean;
  reviewSchemaPart: typeof ReviewSchemaPart;
  reviewPart?: YesNoStructuredPart;
  onChange?: (change: YesNoStructuredPartDefinition) => void;
  validationError?: ValidationError | null;
};

class YesNoFormPart extends React.Component<Props> {
  handleChange = (optionId: $TSFixMe) => {
    if (!this.props.disabled && this.props.onChange) {
      this.props.onChange({ choice: optionId });
    }
  };

  render() {
    const { disabled, reviewSchemaPart, reviewPart, validationError } = this.props;
    const validationLabelId = reviewSchemaPart.id ? `form-part-label-${reviewSchemaPart.id}` : undefined;

    const options = [
      {
        label: 'Yes',
      },
      {
        label: 'No',
      },
    ];

    return (
      <div className="rc-YesNoFormPart">
        <div className="options-prompt">
          <Content assumeStringIsHtml={false} content={reviewSchemaPart.get('prompt')} />
        </div>
        <InlineValidationErrorV2 id={validationLabelId} validationError={validationError} />
        <div role="radiogroup" aria-describedby={validationLabelId} aria-labelledby={validationLabelId}>
          {options.map((option, index) => (
            <div key={option.label}>
              <label className="option">
                <input
                  className="peer-option-input"
                  disabled={disabled}
                  value={option.label}
                  type="radio"
                  checked={reviewPart && option.label === reviewPart.definition.choice}
                  aria-checked={reviewPart && option.label === reviewPart.definition.choice}
                  tabIndex={index}
                  // @ts-expect-error ts-migrate(2322) FIXME: Type 'Function' is not assignable to type 'ChangeE... Remove this comment to see the full error message
                  onChange={_(this.handleChange).partial(option.label)}
                />
                <div className="option-contents">
                  {reviewSchemaPart.get('points') && (
                    <div>
                      <FormattedMessage
                        message={_t('{points, plural, one{# pt} other{# pts}}')}
                        points={reviewSchemaPart.getChoicePoints(option.label)}
                      />
                    </div>
                  )}
                  <div>{option.label}</div>
                </div>
              </label>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default YesNoFormPart;
